'use es6';

import PropTypes from 'prop-types';
import HtmlValidationMessage from './HtmlValidationMessage';
import { Flex } from 'foundations-components/components/Flex';
import Field from './Field';
import { jsx as _jsx } from "react/jsx-runtime";
const HostField = ({
  baseLangKey,
  fieldName,
  fieldProps,
  isExpanded,
  validationMessages,
  value
}) => /*#__PURE__*/_jsx(Flex, {
  flexGrow: 1,
  marginInlineEnd: 200,
  children: /*#__PURE__*/_jsx(Field, Object.assign({}, fieldProps, {
    "aria-hidden": !isExpanded,
    error: Boolean(validationMessages[fieldName]),
    messageKeySuffix: `${baseLangKey}.hostLabel`,
    name: fieldName,
    placeholderKeySuffix: `${baseLangKey}.hostPlaceholder`,
    validationMessage: /*#__PURE__*/_jsx(HtmlValidationMessage, {
      message: validationMessages[fieldName]
    }),
    value: value.get(fieldName)
  }))
});
HostField.propTypes = {
  baseLangKey: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  fieldProps: PropTypes.object.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  validationMessages: PropTypes.object.isRequired,
  value: PropTypes.any.isRequired
};
export default HostField;